<template>
  <div>
    <div class="d-flex flex-row-column">
      <headnavigation :flow="flow" />
      <div class="d-inline-block ml-auto">
        <md-button
          @click="$router.push('/owner/bank/'+id+'/edit')"
          class="md-primary md-raised c-primary"
        >
          <img src="../../../assets/icons/iconButtonEdit.svg" class="mr-2" alt="edit" />Edit
        </md-button>
        <md-button @click="blockUser(id)" class="md-primary md-raised c-primary">
          <img src="../../../assets/icons/iconButtonBlock.svg" class="mr-2" alt="block" />
          <template v-if="data.user && data.user.deleted_at">Unblock</template>
          <template v-else>Block</template>
        </md-button>
        <!--
        <md-button @click="confirmDelete(id,true)" class="md-accent md-raised c-primary">
          <img src="../../../assets/icons/iconButtonDelete.svg" class="mr-2" alt="delete" />Delete
        </md-button>
        -->
      </div>
    </div>
    <hr />
    <div class="form-section my-3">General Bank info</div>
    <b-row v-if="data.role_data">
      <b-col md="1" class="r-text-center r-mb-20">
        <img class="mt-4" src="../../../assets/icons/iconBankInfo.svg" alt="bank" />
      </b-col>
      <b-col md="5">
        <div class="d-flex">
          <div class="gray-text width-200">Bank Name</div>
          <div class="d-inline-block">{{data.role_data.name}}</div>
        </div>
        <div class="d-flex">
          <div class="gray-text width-200">Routing Number</div>
          <div class="d-inline-block">{{data.role_data.routing_number}}</div>
        </div>
        <div class="d-flex">
          <div class="gray-text width-200">Start Date</div>
          <div class="d-inline-block">{{data.role_data.start}}</div>
        </div>
        <div class="d-flex">
          <div class="gray-text width-200">ID Number</div>
          <div class="d-inline-block">{{data.role_data.id_number}}</div>
        </div>
      </b-col>
      <b-col md="6">
        <div class="d-flex">
          <div class="gray-text width-200">Street</div>
          <div class="d-inline-block">{{data.user.street}}</div>
        </div>
        <div class="d-flex">
          <div class="gray-text width-200">Town</div>
          <div class="d-inline-block">{{data.user.city}}</div>
        </div>
        <div class="d-flex">
          <div class="gray-text width-200">State</div>
          <div class="d-inline-block">{{data.user.state.name}}</div>
        </div>
        <div class="d-flex">
          <div class="gray-text width-200">Zip</div>
          <div class="d-inline-block">{{data.user.zip}}</div>
        </div>
      </b-col>
    </b-row>
    <hr class="my-4" />
    <b-row v-if="data.role_data">
      <b-col md="1" class="r-text-center r-mb-20">
        <img src="../../../assets/icons/iconContactInfo.svg" alt="bcontact" />
      </b-col>
      <b-col md="5">
        <div class="d-flex">
          <div class="gray-text width-200">Contact Person</div>
          <div class="d-inline-block">{{data.role_data.contact_person}}</div>
        </div>
        <div class="d-flex">
          <div class="gray-text width-200">Contact Phone</div>
          <div class="d-inline-block">{{data.role_data.contact_phone}}</div>
        </div>
      </b-col>
      <b-col md="6">
        <div class="d-flex">
          <div class="gray-text width-200">E-Mail Address</div>
          <div class="d-inline-block">{{data.user.email}}</div>
        </div>
        <div class="d-flex">
          <div class="gray-text width-200">Password</div>
          <div class="d-inline-block">
            <a @click="resetPassword(data.user.id)" href="#">Reset Password</a>
          </div>
        </div>
      </b-col>
    </b-row>
    <hr class="my-4" />
    <div class="form-section my-3">Compliance Officer info</div>
    <b-row v-if="data.role_data">
      <b-col md="1" class="r-text-center r-mb-20">
        <img class="mt-2" src="../../../assets/icons/iconComplianceOffice.svg" alt="bcontact" />
      </b-col>
      <b-col md="11">
        <div class="d-flex">
          <div class="gray-text width-200">Name</div>
          <div class="d-inline-block">{{data.role_data.compliance_officer.name}}</div>
        </div>
        <div class="d-flex">
          <div class="gray-text width-200">Phone Number</div>
          <div class="d-inline-block">{{data.role_data.compliance_officer.phone}}</div>
        </div>
        <div class="d-flex">
          <div class="gray-text width-200">E-Mail Address</div>
          <div class="d-inline-block">{{data.role_data.compliance_officer.email}}</div>
        </div>
      </b-col>
    </b-row>
<!--    <hr class="my-4" />
    <div class="form-section my-3">Documents</div>
    <b-row class="gray-text">
       <b-col>Type</b-col>
      <b-col>Name</b-col>
      <b-col>Action</b-col>
    </b-row>

      <hr/>
    <b-row class="mb-2" v-if="data.role_data && data.role_data.anti_money_laundering_doc">
      <b-col class="gray-text">Anti-Money Laundering Policies & Procedures</b-col>
      <b-col>{{ data.role_data.anti_money_laundering_doc }}</b-col>     
      <b-col
        ><a :href="data.role_data.anti_money_laundering_doc_link"
          >View Document
        </a></b-col
      >
    </b-row>

      <hr/>
    <b-row class="mb-2"  v-if="data.role_data && data.role_data.banks_bsa_manual_doc">
      <b-col class="gray-text">Banks BSA/AML Manual</b-col>
      <b-col>{{ data.role_data.banks_bsa_manual_doc }}</b-col>

      <b-col
        ><a :href="data.role_data.banks_bsa_manual_doc_link"
          >View Document
        </a></b-col
      >
    </b-row>

      <hr/>
    <b-row class="mb-2"  v-if="data.role_data && data.role_data.boards_written_res_doc">
      <b-col class="gray-text">Boards Written Resolution</b-col>
      <b-col>{{ data.role_data.boards_written_res_doc }}</b-col>
     
      <b-col
        ><a :href="data.role_data.boards_written_res_doc_link"
          >View Document
        </a></b-col
      >
    </b-row>-->
      
    <hr class="my-4" />
    <div class="form-section my-3">Documents</div>
    <b-row v-if="data">
      <b-col>
        <div class="d-flex">
          <div class="gray-text width-50p ml-3">Enhanced AML Policies & Procedures Manual</div>
          <div class="d-inline-block" v-if="data.role_data">
            <a href="javascript:;" @click="downloadFileRequest(data.role_data.anti_money_laundering_doc_link)">{{
              data.role_data.anti_money_laundering_doc
            }}</a>
          </div>
        </div>
        <hr class="my-2" />
        <div class="d-flex">
          <div class="gray-text width-50p ml-3">
            Boards Written Resolution
          </div>
          <div class="d-inline-block" v-if="data.role_data">
            <a href="javascript:;" @click="downloadFileRequest(data.role_data.boards_written_res_doc_link)">{{
              data.role_data.boards_written_res_doc
            }}</a>
          </div>
        </div>
        <hr class="my-2" />
        <div class="d-flex">
          <div class="gray-text width-50p ml-3">Banks BSA/AML Manual</div>
          <div class="d-inline-block" v-if="data.role_data">
            <a href="javascript:;" @click="downloadFileRequest(data.role_data.banks_bsa_manual_doc_link)">{{
              data.role_data.banks_bsa_manual_doc
            }}</a>
          </div>
        </div>
        
      </b-col>
    </b-row>      
      
    <confirm type="bank" right="true" v-if="confirm" @cancel="onCancel" @confirm="onConfirm" />
  </div>
</template>
<script>
// import CRUD methods for users
import Users from "../../../mixins/users.js";

// Confirmation component before deleting user
import ConfirmDelete from "../../../components/owner/ConfirmDelete";

import {fileMixin} from '@/mixins/fileMixin';

export default {
  mixins: [Users, fileMixin],
  components: {
    confirm: ConfirmDelete
  },

  data() {
    return {
      id: this.$route.params.id,
      data: {},
      flow: [
        { text: "Domestic Banks", link: "/owner/bank" },
        { text: "Create Bank Account" }
      ]
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      axios
        .get("/owner/get-user?id=" + this.id)
        .then(({ data }) => {
          this.data = data;
          this.flow[1].text = data.role_data.name;
        })
        .catch(error => {
          this.$router.push("/bank");
        });
    }
  }
};
</script>